import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gfu-project-search-header__content" }
const _hoisted_2 = { "data-qa": "sorting-options-button-selected-sorting" }
const _hoisted_3 = ["data-qa"]
const _hoisted_4 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_search_header = _resolveComponent("search-header")

  return (_openBlock(), _createBlock(_component_search_header, {
    narrow: $props.narrow,
    "use-offset-when-stuck": $options.useHeaderOffset,
    "root-margin": $options.headerRootMargin
  }, {
    default: _withCtx(({ isStuck }) => [
      _createElementVNode("div", {
        class: _normalizeClass(['gfu-project-search-header', {'is-stuck': isStuck}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_base_button, {
            theme: "searchPrimary",
            width: "compact",
            weight: "thin",
            shadow: "tight",
            class: "_ttr",
            onClick: $options.onFiltersClick,
            "data-qa": "filters-button"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_icon, {
                name: "sliders-simple",
                class: "_tc--accent _mr-1"
              }),
              _createElementVNode("strong", null, _toDisplayString(_ctx.Resources.Search.SearchFiltersHeader), 1 /* TEXT */),
              ($props.selectedFiltersCount > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" (" + _toDisplayString($props.selectedFiltersCount) + ") ", 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"]),
          _createVNode(_component_base_button, {
            theme: "searchPrimary",
            width: "compact",
            weight: "thin",
            shadow: "tight",
            class: "_ttr",
            onClick: $options.onSortClick,
            "data-qa": "sorting-options-button"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_icon, {
                name: "bars-sort",
                class: "_tc--accent _mr-1"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.Resources.Search.SearchFiltersSortLabel) + " ", 1 /* TEXT */),
              _createElementVNode("strong", _hoisted_2, _toDisplayString($props.sortDisplayName), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filtersWithDisplayNames, (filter) => {
            return (_openBlock(), _createBlock(_component_base_button, {
              key: filter.key,
              class: "_ttr",
              width: "compact",
              weight: "thin",
              shadow: "tight",
              theme: "searchSecondary",
              onClick: $event => ($options.onDeleteClick(filter)),
              "data-qa": `filter-button:${filter.key}`
            }, {
              default: _withCtx(() => [
                (filter.group)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      "data-qa": `filter-group:${filter.group}`
                    }, _toDisplayString(filter.group) + ": ", 9 /* TEXT, PROPS */, _hoisted_3))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("strong", {
                  "data-qa": `filter-label:${filter.displayName}`
                }, _toDisplayString(filter.displayName), 9 /* TEXT, PROPS */, _hoisted_4),
                _createVNode(_component_base_icon, {
                  name: "times",
                  class: "_ml-1 _tc--lighter",
                  "data-qa": "close-button"
                })
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "data-qa"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["narrow", "use-offset-when-stuck", "root-margin"]))
}